import React from "react";
import { GridEditInputCell, GridEditInputCellProps, GridEditSingleSelectCell, GridEditSingleSelectCellProps, GridSortDirection } from "@mui/x-data-grid-premium";
import { SelectBoxOption } from "../../interfaces";
import { Fields } from "react-spreadsheet-import/types/types";

export const typeOptions = [
    { label: "Material", value: "material" },
    { label: "BOM", value: "bom" },
    // createOption("Document")
]

export interface SortOption {
    sortModel: {
        field: string;
        sort: GridSortDirection;
    }[];
}
// For Main Fields

export const commonSelect: React.FC<
    GridEditSingleSelectCellProps | GridEditInputCellProps
> = (params) => {
    return (
        <GridEditSingleSelectCell
            {...(params as GridEditSingleSelectCellProps)}
        />
    );
};

export const enableFieldBasedOnSelectedType: React.FC<{
    params: GridEditSingleSelectCellProps | GridEditInputCellProps,
    options: SelectBoxOption[],
    field: string | number,
    isDisabled: boolean
}> = ({ params, options, field, isDisabled }) => {
    if (isDisabled) {
        return (
            <GridEditInputCell
                {...(params as GridEditInputCellProps)}
                disabled={isDisabled}
                value={
                    options?.find(
                        (s: SelectBoxOption) => s?._id === field
                    )?.label ?? ""
                }
            />
        );
    }
    return (
        <GridEditSingleSelectCell
            {...(params as GridEditSingleSelectCellProps)}
            disabled={isDisabled}
        />
    );
};

export const enableInputBasedOnCondition: React.FC<GridEditInputCellProps> = (
    params, isDisabled
) => {
    return (
        <GridEditInputCell
            {...params}
            disabled={isDisabled}
        />
    );
};


export const fields: Fields<any>[] = [
    {
        label: "Type",
        key: "Type",
        alternateMatches: ["type", "TYPE"],
        fieldType: {
            type: "select",
            options: [{ label: "BOM", value: "bom" }, { label: "Material", value: "material" }]
        },
        example: "bom or material",
    },
    {
        label: "Region",
        key: "Region",
        alternateMatches: ["region", "REGION"],
        fieldType: {
            type: "input",
        },
    },
    {
        label: "Group",
        key: "Group",
        alternateMatches: ["group", "GROUP"],
        fieldType: {
            type: "input",
        },
    },
    {
        label: "Noun",
        key: "Noun",
        alternateMatches: ["noun", "NOUN"],
        fieldType: {
            type: "input",
        },
    },
    {
        label: "Short Description",
        key: "Short Description",
        alternateMatches: ["short description", "SHORT DESCRIPTION", "Short description", "short Description"],
        fieldType: {
            type: "input",
        }
    },
    {
        label: "Long Description",
        key: "Long Description",
        alternateMatches: ["long description", "LONG DESCRIPTION", "Long description", "long Description"],
        fieldType: {
            type: "input",
        }
    },
    {
        label: "Reference Number",
        key: "Reference Number",
        alternateMatches: ["reference number", "REFERENCE NUMBER", "Reference number", "reference Number"],
        fieldType: {
            type: "input",
        },
    },
    {
        label: "METRIC TYPE",
        key: "METRIC TYPE",
        alternateMatches: ["metric type", "metric_type"],
        fieldType: {
            type: "input",
        },
    },
    {
        label: "METRIC VALUE",
        key: "METRIC VALUE",
        alternateMatches: ["metric value", "metric_value"],
        fieldType: {
            type: "input",
        },
    },
    {
        label: "METRIC UNIT",
        key: "METRIC UNIT",
        alternateMatches: ["metric unit", "metric_unit"],
        fieldType: {
            type: "input",
        },
    },
    {
        label: "Physical Material",
        key: "Physical Material",
        alternateMatches: ["physical material", "PHYSICAL MATERIAL"],
        fieldType: {
            type: "select",
            options: [{ label: "Yes", value: "yes" }, { label: "No", value: "no" }]
        },
        example: "Yes or No",
    },
    {
        label: "Costing Type",
        key: "Costing Type",
        alternateMatches: ["costing type", "COSTING TYPE"],
        fieldType: {
            type: "input",
        },
    },
    {
        label: "Cost",
        key: "Cost",
        alternateMatches: ["cost", "COST"],
        fieldType: {
            type: "input",
        },
    },
    {
        label: "Currency",
        key: "Currency",
        alternateMatches: ["currency", "CURRENCY"],
        fieldType: {
            type: "input",
        },
    },
    {
        label: "Lead Time (Weeks)",
        key: "Lead Time (Weeks)",
        alternateMatches: ["lead time", "Lead Time"],
        fieldType: {
            type: "input",
        },
    },
    {
        label: "Sourcing Type",
        key: "Sourcing Type",
        alternateMatches: ["sourcing type", "SOURCING TYPE"],
        fieldType: {
            type: "input",
        },
    },
    {
        label: "Supplier Name",
        key: "Supplier Name",
        alternateMatches: ["supplier name", "SUPPLIER NAME"],
        fieldType: {
            type: "input",
        },
    },
    {
        label: "Manufacturer Name",
        key: "Manufacturer Name",
        alternateMatches: ["manufacturer name", "MANUFACTURER NAME"],
        fieldType: {
            type: "input",
        },
    },
    {
        label: "Manufacturer Number",
        key: "Manufacturer Number",
        alternateMatches: ["manufacturer number", "MANUFACTURER NUMBER"],
        fieldType: {
            type: "input",
        },
    },
    {
        label: "Unit Name",
        key: "Unit Name",
        alternateMatches: ["unit name", "UNIT NAME"],
        fieldType: {
            type: "input",
        },
    },
    {
        label: "Unit Location",
        key: "Unit Location",
        alternateMatches: ["unit location", "UNIT LOCATION"],
        fieldType: {
            type: "input",
        },
    },
    {
        label: "Other Details",
        key: "Other Details",
        alternateMatches: ["other details", "OTHER DETAILS"],
        fieldType: {
            type: "input",
        },
    },
    {
        label: "Tag Number",
        key: "Tag Number",
        alternateMatches: ["tag number", "TAG NUMBER"],
        fieldType: {
            type: "input",
        }
    },
    {
        label: "Spare Part",
        key: "Spare Part",
        alternateMatches: ["spare part", "SPARE PART"],
        fieldType: {
            type: "select",
            options: [{ label: "Yes", value: "yes" }, { label: "No", value: "no" }]
        },
        example: "Yes or No",
    },
    {
        label: "Spare Part Category",
        key: "Spare Part Category",
        alternateMatches: ["spare part category", "SPARE PART CATEGORY"],
        fieldType: {
            type: "input",
        },
    },
    {
        label: "Spare Part Qty",
        key: "Spare Part Qty",
        alternateMatches: ["spare part qty", "SPARE PART QTY"],
        fieldType: {
            type: "input",
        },
    },
    {
        label: "Qty",
        key: "Qty",
        alternateMatches: ["qty", "QTY"],
        fieldType: {
            type: "input",
        },
    },
    {
        label: "Override cost per qty",
        key: "Override cost per qty",
        alternateMatches: ["Override Cost Per Qty", "override cost per qty", "OVERRIDE COST PER QTY"],
        fieldType: {
            type: "input",
        },
    },
    {
        label: "Remarks",
        key: "Remarks",
        alternateMatches: ["remarks", "REMARKS"],
        fieldType: {
            type: "input",
        },
    },
    {
        label: "Notes",
        key: "Notes",
        alternateMatches: ["notes", "NOTES"],
        fieldType: {
            type: "input",
        },
    },
];

export const defaultSortState = { sortModel: [{ field: 'validation_errors', sort: 'desc' as GridSortDirection }] };